import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourseService } from 'src/app/services/course/course.service';
import { AddExamComponent } from '../add-exam/add-exam.component';
import { AddCourseComponent } from '../add-course/add-course.component';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from 'src/app/services/app/app.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { Filter } from '../../filter/filter.model';
import { PaginationInstance } from 'ngx-pagination';
import { CommonService } from 'src/app/services/common/common.service';
import { AlertComponent } from '../../alert/alert.component';
import { ViewCoursePreviewComponent } from '../view-course-preview/view-course-preview.component';
import { AgreeTermsConditionComponent } from '../../package-management/agree-terms-condition/agree-terms-condition.component';

@Component({
  selector: 'app-course-dashboard',
  templateUrl: './course-dashboard.component.html',
  styleUrls: ['./course-dashboard.component.scss', '../../../../assets/scss/common/_course-box.scss']
})
export class CourseDashboardComponent {
  @Input() isCourseBuilder!: boolean;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public count!: any;
  public courseArr: any[] = [
  ]
  public isSpinnerLoading: boolean = false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", }
  public imageUrl = GlobalService.imageURL;
  public filteredItems: any[] = []
  public isAdmin: boolean = false;
  public isFilterShow: boolean = false;
  public filterObj: Filter = {
    operand: "and",
    arr: []
  }
  public filterArr: any[] = [
    { key_name: "Title", key_val: "tit", type: 'text' },
    { key_name: "Description", key_val: "desc", type: 'text' },
  ]
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public searchInput: string = '';
  private previousInputValue: string = '';
  public userType: any;
  constructor(private courseService: CourseService, private spinner: NgxSpinnerService, private router: Router, public dialog: MatDialog,
    private cookieService: CookieService, private appService: AppService, private commonService: CommonService) { }

  ngOnInit(): void {


    if (this.isCourseBuilder) {
      this.commonService.setTitle("Course Builder")
    }
    else {
      this.commonService.setTitle("Course Dashboard")
    }
    this.checkUserType();

  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
    if (!this.isFilterShow && this.filterObj.arr.length > 0) {
      this.filterObj.arr = [];
      this.onCourseList()
    }
  }

  calculatePercentage(part, whole) {
    return (part / whole) * 100;
  }
  checkUserType() {


    if (this.cookieService.get('user_id') && window.location.href.includes('cdashboard')) {
      // whenever admin user set the token of admin 
      this.appService.storeData('training-portal.admin-authToken', this.cookieService.get('user_id'));
      this.appService.storeSessionData('isAdmin', JSON.stringify(true));
      this.isAdmin = true;
      this.isCourseBuilder = true;

    }
    else {
      this.isAdmin = false;
      let userObj = JSON.parse(this.appService.getData('training-portal.userInfo'))
      this.userType = userObj['group_type']
    }
    this.onPageChange(1)
    // this.onCourseList();
  }
  callApi(obj) {
    this.filterObj = obj
    this.checkUserType()
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.onCourseList()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.onCourseList()
  }
  onCourseList() {
    this.isSpinnerLoading = true
    // this.spinner.show()
    this.courseArr = []
    this.filteredItems = [];
    let obj = {
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      sh: this.searchInput.trim(),
      op_nd: this.filterObj.operand,
      f_a: this.filterObj.arr
    }
    // alert(this.isCourseBuilder)
    if (this.isCourseBuilder) {
      this.courseService.courseList(obj).subscribe({
        next: (response: any) => {
          this.courseResponse(response)
        },
        error: (error: any) => {
          this.previousInputValue = this.searchInput;
          this.isSpinnerLoading = false;
          this.commonService.handleError(error)
        }
      })
    }
    else {
      this.courseService.courseDashboard(obj).subscribe({
        next: (response: any) => {
          this.courseResponse(response)
        },
        error: (error: any) => {
          this.previousInputValue = this.searchInput;
          this.isSpinnerLoading = false;
          this.commonService.handleError(error)
        }
      })
    }

  }
  courseResponse(response) {
    this.previousInputValue = this.searchInput;
    this.isSpinnerLoading = false;
    if (response.status == 200) {

      this.count = response["count"]
      this.courseArr = response["msg"]
      for (let i = 0; i < this.courseArr.length; i++) {
        if (this.courseArr[i].hasOwnProperty('acc')) {
          this.courseArr[i]["admin_course"] = 'yes'
        }
        else {
          this.courseArr[i]["admin_course"] = 'no'
        }
      }
      this.filteredItems = [...this.courseArr];
    }
  }
  onDeleteCourse(c_i: any, t) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_course", c_i: c_i, t: t }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["delete_content"] == true) {
          this.onCourseList()
        }
      }
    });
  }
  onHideCourse(c_i: any) {
    const dialogRef = this.dialog.open(AlertComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_course", c_i: c_i }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["delete_content"] == true) {
          this.onCourseList()
        }
      }
    });
  }
  onViewCourse(id: any, p_id: any, admin_course: string, t: string) {
    if (this.userType == 'company' || this.userType == 'manager') {
      if (window.location.href.includes('dashboard')) {
        this.router.navigate(['/course/dashboard/view'], { queryParams: { id: id, package_id: p_id, ad_c: this.appService.getEncryptedText(admin_course), t: t } })
      }
      else {
        this.router.navigate(['/course/builder/view'], { queryParams: { id: id, package_id: p_id, ad_c: this.appService.getEncryptedText(admin_course), t: t } })
      }

    }

  }
  onManageExam(id: any, type, is_info) {
    if (is_info == 1) {
      this.appService.showToastMessage('warning', "This is informational course hence you cannot set the exam ")
      return
    }
    if (type == "average") {
      this.appService.showToastMessage('warning', "Section wise exam is set for this course. So, you can't create final exam")
      return
    }
    // any changes made here also make changes in add course component
    const dialogRef = this.dialog.open(AddExamComponent, {
      width: '96%',
      height: '96%',
      maxWidth: '100vw',
      maxHeight: "800px",
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: { c_i: id, exam_type: "o_e" }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onEditCourse(item: any) {
    item["c_type"] = 0
    if (item["admin_course"] == 'no') {
      item["c_type"] = 1
    }
    const dialogRef = this.dialog.open(AddCourseComponent, {
      width: '96%',
      height: '94%',
      maxHeight: "800px",
      maxWidth: '100vw',
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: { data: item },
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["content_edited"]) {
          this.onCourseList()
        }
      }
    });
  }
  onAddCourse() {
    const dialogRef = this.dialog.open(AddCourseComponent, {
      width: '96%',
      height: '94%',
      // maxHeight: "800px",
      maxWidth: '100vw',
      panelClass: 'addCourseModal',
      enterAnimationDuration: '200ms', exitAnimationDuration: "300ms",
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["content_edited"]) {
          this.onCourseList()
        }
      }
    });
  }
  handleBackgroundImageError(event: any) {
    event.target.style.backgroundImage = `url(assets/images/object_icons/default_course.png)`;
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.onPageChange(1)
    }
  }
  onGo() {
    if (this.searchInput.trim() != '') {
      this.onPageChange(1)
    }
  }
  setBgImg(image: any, i: any) {
    return this.filteredItems[i]["image"] = ""
  }
  onCoursePreview(item) {
    let data = {
      id: item.c_i,
      t: item.t,
      parentMenu: 'preview_course'
    }
    const dialogRef = this.dialog.open(ViewCoursePreviewComponent, {
      width: '96%',
      height: '98%',
      // maxHeight: "800px",
      maxWidth: '100vw',
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  
  onAgreeCourse() {
    const dialogRef = this.dialog.open(AgreeTermsConditionComponent, {
      panelClass: 'agree-modal',
      enterAnimationDuration: '300ms', 
      exitAnimationDuration: "300ms",
    });
    dialogRef.afterClosed().subscribe(result => {
      
    });
  }
}
